
import React, { useState, useEffect } from 'react';

import { loginRequest, protectedResources } from "../../authConfig";
//import { useGetSkillData, useUpdateSkillData } from '../../hooks/useSkillData';
import { ISkill } from '../../model/Skill.model';
import { IsCookieFunction } from 'react-router-dom';
import useFetchWithMsal from '../../hooks/useFetchWithMsal';
import { ISkillLevel } from '../../model/SkillLevel.model';
import Modal from '../Modal/Modal';
import EditSkillDetailsComponent from './EditSkillDetailsComponent';
import { Icon } from '../icons/icons';
import './EditSkillComponent.scss';
import IconHoverButton from '../IconHoverButton/IconHoverButton';

export interface SkillIdComponentState {
  id:any;
  Skill:ISkill;
  SkillLevels:ISkillLevel[];
  index: number,
  skillDeleted(event: ISkill): void;
  moveSkillUp(event:ISkill, index:number):void;
}

const EditSkillComponent: React.FC<SkillIdComponentState> = ({id,Skill, SkillLevels, index, skillDeleted, moveSkillUp}) => {
    const [editingAtts, seteditingAtts] = useState(false);
    const [deletingSkill, setDeletingSkill] = useState<ISkill | null>(null);
    const [errorMessage, setErrorMessage] = useState('');
    const initialData = JSON.parse(JSON.stringify(Skill));
    const [item, setItem] = useState(Skill);
    const [SkillId, setSkillId] = useState(id);
    const { error, execute } = useFetchWithMsal({
      scopes: protectedResources.apiCFSkillPath.scopes.read,
    });
    const [loading, setLoading] = useState(true);
    const [callErr, setErr] = useState(null);

    const handleEditAttributesTask = (SkillUpdated:ISkill) => {
      execute("PUT", `/api/Skill/updateSkill`, SkillUpdated)
        .then((response:any) => {
          setItem(response);
          setLoading(false);
          seteditingAtts(false);
        }).catch((err:any) => {
          setErr(err);
          setLoading(false);
        })
    }
    const toggleEditThisSkill =() => {
        seteditingAtts(!editingAtts);
    }
    const DeleteSkill = (skill:ISkill) => {
      execute("DELETE", `/api/Skill/deleteSkill/${skill.SkillId}`)
      .then((response:any) => {

        ToggleDeletingSkill(null);
        skillDeleted(skill);
      }).catch((err:any) => {
        setErr(err);
        setLoading(false);
        ToggleDeletingSkill(null);
        setErrorMessage('Error deleting skill. Most likely a bookmark or child record exists.');
      })
    }
    const ToggleDeletingSkill = (skill: ISkill | null) => {
      setDeletingSkill(skill);
    }
    const MoveUpSkill = (skill: ISkill | null) => {
      if (!skill) return;
      moveSkillUp(skill, index);
    }
    const CloseEditing = () => {
      seteditingAtts(false)
    }
    const handleAddNewSkill = (event:any) => {}
    return <>
    <div key={id}><Modal isOpen={errorMessage !== ''}><div>{errorMessage}</div></Modal>
        {editingAtts ? (
            <>
              <>{Skill.skillName}</>
              <Modal modalTitle='Edit Skill Details' isOpen={true} onClose={CloseEditing}>
                <EditSkillDetailsComponent SkillLevels={SkillLevels} Skill={Skill} addNewSkillData={handleAddNewSkill} updateSkillData={handleEditAttributesTask} />  
                <div className='modal-form-button-container'>
                  <button className='btn-secondary' onClick={toggleEditThisSkill}>Close</button>
                </div>
              </Modal>
            </>
        ) : (
            <div className='dis-flex dis-flex-aln-center gap--50'>
              <span className='dis-flex-grow-1'>{Skill.skillName}</span>
              {index>0 && (

                <button 
                  className='btn-icon bg-white edit-skill-component-edit-button' 
                  onClick={() => MoveUpSkill(Skill)}
                  title='Move Up'>
                  <Icon
                    name="icon-arrow-up"
                    className='icon-secondary' />
                </button>

              )}
              {index===0 && (<span>&nbsp;</span>)}

                <button 
                  className='btn-icon bg-white edit-skill-component-edit-button' 
                  onClick={toggleEditThisSkill}
                  title='Edit Skill'>
                  <Icon
                    name="icon-pencil"
                    className='icon-secondary' />
                </button>

                <button 
                  className='btn-icon bg-white edit-skill-component-edit-button' 
                  onClick={() => ToggleDeletingSkill(Skill)}
                  title='Delete Skill'>
                  <Icon
                    name="icon-trash-no-circle"
                    className='icon-secondary' />
                </button>
            </div>
        )}
        
    </div>
    {deletingSkill!==null && (<>
    <Modal isOpen={deletingSkill!==null} modalTitle='Delete Skill'>
      <div className="modal-form-content-scroll-container">
        Are you sure you want to delete this skill?
      </div>
      <div className="modal-form-button-container two-button">
        <button className="btn-med-gray" onClick={(e) => ToggleDeletingSkill(null)}>No</button>
        <button className="btn-secondary" onClick={(e) => DeleteSkill(deletingSkill)}>Yes</button>
      </div>
    </Modal></>)}
    </>;
}
export default EditSkillComponent;

